import { formatPrice } from "../../utils/formatPrice";
import { useState, useEffect, type ChangeEvent } from "react";

interface CurrencyInputFieldProps {
  id: string;
  label: string;
  placeholder?: string;
  value: string;
  onChange: (rawValue: string) => void;
  autoComplete?: string;
}

export const CurrencyInputField = ({
  id,
  label,
  placeholder = "",
  value,
  autoComplete = "off",
  onChange,
}: CurrencyInputFieldProps) => {
  const [displayValue, setDisplayValue] = useState(value);

  useEffect(() => {
    setDisplayValue(`$${formatPrice(value)}`);
  }, [value]);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value.replace(/[^0-9]/g, "");

    setDisplayValue(`$${formatPrice(rawValue)}`);
    onChange(rawValue);
  };

  return (
    <div className="w-full relative">
      <label
        htmlFor={id}
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {label}
      </label>
      <input
        type="tel"
        id={id}
        value={displayValue}
        onChange={handleInputChange}
        autoComplete={autoComplete}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-z-dark-moss-green focus:border-z-dark-moss-green block w-full p-2.5"
        placeholder={placeholder}
      />
    </div>
  );
};
